import { useCallback } from 'react'
import {
  getTreatmentConversionFunnelReport,
  type ReportBucketType,
  type TreatmentConversionFunnelReportResult,
} from '@services/api/reports/engagement.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type TreatmentConversionFunnelData =
  TreatmentConversionFunnelReportResult

export type UseTreatmentConversionFunnelResult = {
  loading: boolean
  error: string | null
  data: TreatmentConversionFunnelData | null
  bucketLabel: string
}

export function useTreatmentConversionFunnel(
  toolbarSelection: Record<string, string>,
): UseTreatmentConversionFunnelResult {
  const getBucketFromData = useCallback(
    (data: TreatmentConversionFunnelReportResult): ReportBucketType =>
      data.acceptanceRateTrend.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getTreatmentConversionFunnelReport,
    getBucketFromData,
    errorMessage: 'Failed to load treatment conversion funnel data',
  })
}
